import { createFileRoute, redirect } from "@tanstack/react-router";

// People type /sign-in out of habit; the sign-in page lives at /auth.
export const Route = createFileRoute("/sign-in")({
  beforeLoad: ({ search }) => { throw redirect({ to: "/auth", search, replace: true }); },
});
